export const FormHandler = {
    validate: fieldSet => {
        let result = true;
        Object.keys(fieldSet).forEach(k => {
            const field = fieldSet[k];
            const fieldResult = FormHandler.validateField(field, fieldSet);
            if (!fieldResult) result = false;

        })
        return result;
    },

    validateField: (field, fieldSet) => {
        let validResult = true;
        field.isValid = true;
        if (!field.originalValidationMessage) {
            field.originalValidationMessage = [...field.validationMessages];
        }
        field.validationMessages = [...field.originalValidationMessage];

        field.rules.forEach((rule, index) => {
            const ruleResult = rule(field, fieldSet);
            if (!ruleResult) validResult = false;
        });

        return validResult;
    },

    handleInputChange: (name, value, fields) => {
        setFieldValue(name, value, fields, true);
    },

    setFieldValuesFromObject: (fields, object, validate) => {
        Object.keys(object).forEach(k => {
            const v = object[k];
            setFieldValue(k, v ? v : "", fields, validate);
        })

    },

    // WARNING!!! ... there may be a SIZE LIMIT on the property names for the array-style property-setter
    //  ... not sure if this is a javascript or ES6 thingy, or whatever...
    //  ... my tests with a 45-character property name failed. Drats.
    getAllValues: fields => {
        const allValues: any[] = [];
        Object.keys(fields).forEach(key => {
            const f = fields[key];
            allValues.push({ [f.name]: f.value });
        });

        return allValues;
    },

    // WARNING!!! ... there may be a SIZE LIMIT on the property names for the array-style property-setter
    //  ... not sure if this is a javascript or ES6 thingy, or whatever...
    //  ... my tests with a 45-character property name failed. Drats.
    getAllValuesAsObject: fields => {
        const allValues: any = {};
        Object.keys(fields).forEach(key => {
            const f = fields[key];
            allValues[f.name] = f.value;
        });
        return allValues;
    }
};

const setFieldValue = (name, value, fields, validate) => {

    Object.keys(fields).forEach(k => {
        const f = fields[k];
        if (f.name === name) {
            f.value = value;
            if (validate) FormHandler.validateField(f, fields);
        }

    })
};
